module.exports = __webpack_public_path__ + "img/code_file_icon.aa80ee83.svg";